import React, {SetStateAction, memo, useMemo, useState, useEffect, useLayoutEffect} from "react";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { Button, Dropdown, MenuProps } from "antd";
import "./SlidesBar.scss";
import { DisplayMode } from "../../types";
import { ExcalidrawFrameLikeElement } from "../../element/types";
import {KEYS} from "../../keys";
import {postMessage, recvMessage} from "../../../../../src/common/event";
import {
    EVENT_COPY_DOC_NOTE,
    EVENT_FRAME_PAGE_DESC_VISIBLE, EVENT_FRAME_PAGES, EVENT_FRAME_PREVIEW_BY_ID,
    EVENT_FRAME_PREVIEW_LAST,
    EVENT_FRAME_PREVIEW_NEXT
} from "../../../../../src/Const";
import {imgPathPerfix} from "../../../../../src/utils";

interface SlidesBarProps {
  displayMode: DisplayMode;
  frames: readonly ExcalidrawFrameLikeElement[];
  changePreviewFrame: (
    frame: ExcalidrawFrameLikeElement,
    frameIndex: number,
  ) => void;
}

const SlidesBar = memo(
  ({ displayMode, frames, changePreviewFrame }: SlidesBarProps) => {
    const [frameIndex, setFrameIndex] = useState(0);
    const [isShowOverlay,setIsShowOverlay] = useState(false);

    const onKeydownListener = (e)=>{
        e.preventDefault();
        if (e.keyCode === 37){
            //left
            changeFrame(frameIndex - 1);
        }else if (e.keyCode === 39){
            //right
            changeFrame(frameIndex + 1);
        }
    }

    useLayoutEffect(()=>{
        // document.body.addEventListener('keydown',onKeydownListener);
        // return ()=>{
        //     document.body.removeEventListener('keydown',onKeydownListener);
        // }
        recvMessage(EVENT_FRAME_PREVIEW_LAST,(msg,data)=>{
            let nNext = frameIndex - 1;
            changeFrame(nNext);
            // postMessage(EVENT_FRAME_PAGES,(nNext)+' / '+frames.length)
        },true)
        recvMessage(EVENT_FRAME_PREVIEW_NEXT,(msg,data)=>{
            let nNext = frameIndex+1;
            changeFrame(nNext);

        },true)
        recvMessage(EVENT_FRAME_PREVIEW_BY_ID,(msg,data)=>{
            const frameIndex = frames.findIndex((frame) => frame.id === data.data.id);
            changeFrame(frameIndex);
            postMessage(EVENT_FRAME_PAGES,(frameIndex)+' / '+frames.length)
        },true)
        recvMessage(EVENT_FRAME_PAGE_DESC_VISIBLE,(msg,data)=>{
            setIsShowOverlay(data.data.isShowOverlay)
        },true);
    })

    const changeFrame = (frameIndex: number) => {
        if (frameIndex >= frames.length){
            frameIndex = 0;
        }
        if (frameIndex < 0){
            frameIndex = frames.length - 1;
        }

      changePreviewFrame(frames[frameIndex], frameIndex);
      setFrameIndex(frameIndex);

        setTimeout(()=>{
            postMessage(EVENT_FRAME_PAGES,(frameIndex+1)+' / '+frames.length)
        },100)
    };
    const handleMenuClick: MenuProps["onClick"] = (e) => {
      const frameIndex = frames.findIndex((frame) => frame.id === e.key);
      changeFrame(frameIndex);
    };

    const frameItems: MenuProps["items"] = useMemo(() => {
      return frames.map((frame, index) => ({
        key: frame.id,
        label: `Frame${index + 1}`,
        onClick: handleMenuClick,
      }));
    }, [frames]);

    if (!frames.length) {
      return null;
    }
    return (
        <div className="slides-bar" style={{display:'none'}}>
            {/*<Button*/}
            {/*    type="primary"*/}
            {/*    disabled={!frameIndex}*/}
            {/*    icon={<ArrowLeftOutlined rev={undefined}/>}*/}
            {/*    onClick={() => {*/}
            {/*        changeFrame(frameIndex - 1);*/}
            {/*    }}*/}
            {/*/>*/}

            {/*<Dropdown*/}
            {/*    menu={{items: frameItems}}*/}
            {/*    placement="top"*/}
            {/*    arrow={{pointAtCenter: true}}*/}
            {/*>*/}
            {/*    <Button type="text">{`Frame${frameIndex + 1}/${*/}
            {/*        frames.length*/}
            {/*    }`}</Button>*/}
            {/*</Dropdown>*/}
            {/*<Button*/}
            {/*    type="primary"*/}
            {/*    disabled={frameIndex === frames.length - 1}*/}
            {/*    icon={<ArrowRightOutlined rev={undefined}/>}*/}
            {/*    onClick={() => {*/}
            {/*        changeFrame(frameIndex + 1);*/}
            {/*    }}*/}
            {/*/>*/}

            {
                isShowOverlay &&
                <div className='bottom-present-page flex-center'>
                    <img className='img-mini-small-10 cursor-pointer' src={imgPathPerfix() + 'small_arrow_left.png'}
                         onClick={() => {
                             changeFrame(frameIndex + 1);
                         }}/>
                    <span style={{color: "white", margin: '0 6px'}}>{`${(frameIndex + 1)} / ${frames.length}`}</span>
                    <img className='img-mini-small-10 cursor-pointer' src={imgPathPerfix() + 'small_arrow_right.png'}
                         onClick={() => {
                             changeFrame(frameIndex + 1);
                         }}/>
                </div>
            }


        </div>
    );
  },
);

export default SlidesBar;
